import { dispatch } from "../store/store";
import { logError } from "../services/logService";
import {
  getMarketPlaceApps,
  createCompanyMarketAppData,
  deleteCompanyMarketAppData,
  getCompanyMarketplaceAppsData,
  createAccountData,
  recreateLinkData,
  validateAccountRegisteredData,
  getCompaniesData,
  getCompanyMarketplaceAppsByCompanyIdData
} from "../features/marketAppSlice/marketAppSlice";

export const getmarketApps = async () => {
  let result = [];
  try {
    result = await dispatch(getMarketPlaceApps()).unwrap();
  } catch (error) {
    result = [];
  }
  return result;
};

export const createCompanyMarketApp = async (data) => {
  let result = null;

  try {
    result = await dispatch(createCompanyMarketAppData(data)).unwrap();
  } catch (error) {
    logError(error);
    result = null;
  }

  return result;
};

export const deleteCompanyMarketApp = async (data) => {
  let result = null;

  try {
    result = await dispatch(deleteCompanyMarketAppData(data)).unwrap();
  } catch (error) {
    logError(error);
    result = null;
  }

  return result;
};

export const getCompanyMarketplaceApps = async (companyID) => {
  let result = [];
  try {
    result = await dispatch(getCompanyMarketplaceAppsData(companyID)).unwrap();
  } catch (error) {
    result = [];
  }
  return result;
};

export const createAccount = async (data) => {
  let result = null;

  try {
    result = await dispatch(createAccountData(data)).unwrap();
  } catch (error) {
    logError(error);
    result = null;
  }

  return result;
};

export const recreateLink = async (data) => {
  let result = null;

  try {
    result = await dispatch(recreateLinkData(data)).unwrap();
  } catch (error) {
    logError(error);
    result = null;
  }

  return result;
};

export const validateAccountRegistered = async (email) => {
  let result = [];
  try {
    result = await dispatch(
      validateAccountRegisteredData(email)
    ).unwrap();
  } catch (error) {
    logError(error);
    result = [];
  }

  return result;
};

export const getCompanies = async (searchType, keyword) => {
  let result = [];

  try {
    result = await dispatch(
      getCompaniesData({ searchType, keyword })
    ).unwrap();
  } catch (error) {
    result = [];
  }

  return result;
};
export const getCompanyMarketplaceAppsByCompanyId = async (companyID) => {
  let result = [];
  try {
    result = await dispatch(getCompanyMarketplaceAppsByCompanyIdData(companyID)).unwrap();
  } catch (error) {
    result = [];
  }
  return result;
};
